export const DATA_TEST_IDS = {
  MODAL: 'modal_request_playback_report',
  CONTENT: 'request_playback_report_content',
} as const;
